import { useRouteError } from 'react-router-dom'

import { Button } from '@/components/ui'

export function RouteErrorBoundary() {
  const error = useRouteError()
  console.error('Erro de rota:', error)

  return (
    <div className="grid min-h-dvh place-items-center bg-bg p-6">
      <div className="max-w-sm space-y-3 text-center">
        <h1 className="text-lg font-semibold text-fg">Não foi possível abrir esta página</h1>
        <p className="text-sm text-fg-muted">
          Tente recarregar. Se o problema persistir, feche e abra o aplicativo novamente.
        </p>
        <Button onClick={() => window.location.assign('/')}>Ir para o início</Button>
      </div>
    </div>
  )
}
